import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemRows extends DrawingDataItem {
    constructor() {
        super();
        this.typeValue = 'rows';
        this.properties = {
            origin: undefined,
        }
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        return [
            DrawingDataItemPoint.fromVisiblePoint(this.properties.origin),
        ];
    }

    public onMouseDown(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        if (this.properties.origin) {
            return {
                changed: false,
                stillDrawing: false
            };
        }

        this.properties.origin = {
            y: canvasRelativeY,
        }
        return {
            changed: true,
            stillDrawing: true
        };
    }

    public onMouseMove(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        this.properties.origin = {
            y: canvasRelativeY,
        }
        return {
            stillDrawing: true,
            changed: true
        };
    }

    public draw(ctx: CanvasRenderingContext2D) {
        if (this.properties.origin) {
            // Récupérer les dimensions du canvas
            const canvas = ctx.canvas;
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            // Définir les positions en Y des lignes
            const mainLineY = this.properties.origin.y;
            const topLineY = mainLineY - this.common.size;
            const bottomLineY = mainLineY + this.common.size;

            // Appliquer le style commun
            this.applyCommonToCanvas(ctx);

            // Dessiner la ligne principale si elle est dans le canvas
            if (mainLineY >= 0 && mainLineY <= canvasHeight) {
                ctx.beginPath();
                ctx.moveTo(0, mainLineY);
                ctx.lineTo(canvasWidth, mainLineY);
                ctx.stroke();
            }

            // Dessiner la ligne supérieure si elle est dans le canvas
            if (topLineY >= 0 && topLineY <= canvasHeight) {
                ctx.beginPath();
                ctx.moveTo(0, topLineY);
                ctx.lineTo(canvasWidth, topLineY);
                ctx.stroke();
            }

            // Dessiner la ligne inférieure si elle est dans le canvas
            if (bottomLineY >= 0 && bottomLineY <= canvasHeight) {
                ctx.beginPath();
                ctx.moveTo(0, bottomLineY);
                ctx.lineTo(canvasWidth, bottomLineY);
                ctx.stroke();
            }
        }
    }
}